import React from 'react';
import { cssVars } from '@/app/styles';
import { RentalSizeChart } from '@/chart/components/all-charts';
import { HorizontalColorBar } from '@/chart/components/horizontal-color-bar';
import { subtypeChartLabels } from '@/constants';
import { OnlinePlatformsList } from '@/list/components/online-platforms-list';
import { messageBuilder } from '@/utils/string-utils';
import * as SP from './side-panel-styles';

function sidebarDataBuilder(data, dataType) {
  const dataset = []; // Assume no data initially
  Object.entries(data[dataType]).forEach(([key, value]) => {
    const label = subtypeChartLabels[dataType][key];
    const color = cssVars.color.subtype[dataType][key];
    // Builds Object in format needed by HorizontalColorBar / OnlinePlatformsList
    const dataConfiguration = {
      label, // Used by both
      value: value.value, // Used by both
      percentage: value.percentage, // used by OnlinePlatformList
      message: messageBuilder(value.value, value.percentage), // used by HorizontalColorBar
      color, // used by HorizontalColorBar
    };
    dataset.push(dataConfiguration);
  });
  return dataset;
}

/**
 * Wrapper for content to be rendered in the sidebar. Includes titles and margins
 *
 * @param {*} props
 * @param {string} title
 * @param {func} dataRenderer callback render export function for children of the component
 */
export function SidePanelItem(props) {
  return (
    <SP.SidePanelItemWrapper>
      <SP.ItemTitle>{props.title}</SP.ItemTitle>
      {props.dataRenderer()}
    </SP.SidePanelItemWrapper>
  );
}

// we don't have the side panel anymore
// TODO: rename it with RentalCategories
export function SidePanelBody({ kpiData: { latestKpi } }) {
  return (
    <SP.SidePanelBodyWrapper>
      <SidePanelItem
        title="Unit Type"
        dataRenderer={() => (
          <HorizontalColorBar
            data={sidebarDataBuilder(latestKpi, 'rentalType')}
          />
        )}
      />
      <SidePanelItem
        title="Residential Type"
        dataRenderer={() => (
          <HorizontalColorBar
            data={sidebarDataBuilder(latestKpi, 'residentialType')}
          />
        )}
      />
      <SidePanelItem
        title="Rental Structure"
        dataRenderer={() => (
          <HorizontalColorBar
            data={sidebarDataBuilder(latestKpi, 'rentalStructure')}
          />
        )}
      />
    </SP.SidePanelBodyWrapper>
  );
}

// TODO: Treat this as a chart during refactor.. same for everything else in this file
export function OnlinePlatformsSidepanelItem({ kpiData: { latestKpi } }) {
  return (
    <OnlinePlatformsList
      data={sidebarDataBuilder(latestKpi, 'onlinePlatforms')}
    />
  );
}

export function RentalSizeSidepanelItem({ kpiData }) {
  // use the latest kpi, and put it in arrary
  return (
    <SidePanelItem
      title="Rental Size"
      dataRenderer={() => <RentalSizeChart data={kpiData} />}
    />
  );
}
